<!--
  App.vue — 应用根组件

  职责：作为 Vue Router 的顶层容器，渲染当前路由匹配的页面组件。
  本身不包含额外逻辑，所有页面布局由 MainLayout 或独立页面处理。
-->
<template>
  <router-view />
</template>

<script setup lang="ts">
/* 根组件无需额外逻辑，router-view 负责渲染匹配的路由组件 */
</script>
